import { updateLog } from "@/mocks/home";

export default function UpdatesSection() {
  return (
    <section id="updates" className="border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
              更新日志
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              地址与入口更新记录
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              本页会记录近期的线路与入口调整，方便你判断当前地址是否是最新的，
              也便于回访时快速了解都有哪些变化。
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-secondary-100 px-4 py-2 text-xs text-secondary-900">
            <i className="ri-history-line" aria-hidden="true"></i>
            共记录 {updateLog.length} 条近期更新
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
          {updateLog.map((log) => (
            <div
              key={log.date + log.title}
              className="relative flex gap-4 rounded-xl border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <div className="flex flex-col items-center">
                <span className="mt-1 h-3 w-3 shrink-0 rounded-full bg-accent-500"></span>
                <span className="mt-2 w-px flex-1 bg-background-300"></span>
              </div>
              <div>
                <span className="text-xs text-foreground-600">{log.date}</span>
                <h3 className="mt-1 font-heading text-base text-foreground-950">{log.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{log.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}